import React from "react";
import { Switch, Route } from "react-router-dom";
import SpecialtiesLayout from "./SpecialtiesLayout";
import SpecialtyDetailsLayout from "./SpecialtyDetailsLayout";
import { FollowDialogProvider } from "../../components/FollowDialog/FollowDialogContext";

export default function SpecialtiesRoutes() {
  return (
    <FollowDialogProvider>
      <Switch>
        <Route path="/browse/specialties" exact component={SpecialtiesLayout} />
        <Route
          path="/browse/specialties/:specialtyId"
          exact
          component={SpecialtyDetailsLayout}
        />
        <Route
          path="/browse/patient-information"
          exact
          component={SpecialtiesLayout}
        />
        <Route
          path="/browse/patient-information/:specialtyId"
          exact
          component={SpecialtyDetailsLayout}
        />
      </Switch>
    </FollowDialogProvider>
  );
}
